// extracted by mini-css-extract-plugin
export default {"partners-grid":"TranslatePartnerSectionForm_partners-grid__6Y-L0","partner-row":"TranslatePartnerSectionForm_partner-row__WXjgG"};